import React from 'react';

import gfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';

import {Container} from '../../components/container';
import {Grid, GridColumn} from '../../components/grid';

export interface ITemplateHelpProps {
    content?: string;
}

const TemplateHelp = (props: ITemplateHelpProps): JSX.Element => (
    <Container>
        <Grid justify={['center-xs']}>
            <GridColumn width={['md-8', 'lg-6']}>
                {props.content &&
                    <ReactMarkdown className="text" remarkPlugins={[gfm]}>
                        {props.content}
                    </ReactMarkdown>
                }
            </GridColumn>
        </Grid>
    </Container>
);

export default TemplateHelp;
